/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2022
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { createRoot } from "react-dom/client";

import Root from "./Root";

const render = () => {
  const container = document.getElementById("root");
  const root = createRoot(container);
  root.render(<Root />);
};

render();

if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept("./containers/App", render);
}
